import { render, staticRenderFns } from "./lkuKoranNonCustomer.vue?vue&type=template&id=5ed336f6"
import script from "./lkuKoranNonCustomer.vue?vue&type=script&lang=js"
export * from "./lkuKoranNonCustomer.vue?vue&type=script&lang=js"
import style0 from "./lkuKoranNonCustomer.vue?vue&type=style&index=0&id=5ed336f6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports